import React, { useState } from 'react'
import Drawer from 'components/Drawer'
import GroupCollegeContent from './partials'
import GroupCollegeHeader from './partials/GroupCollegeHeader'
import { BodyStyleDiv } from './style/style'
import { useEffect } from 'react'

const GroupCollegeDrawer = ({
  viewGroupCollege,
  setviewGroupCollege,
  groupCreationDrawerVisible,
  setGroupCreationDrawerVisible,
  getMatchedInstituteList,
  instituteGroupList,
  handleEditTier,
  handleEditPOC,
  pocList,
  handleAddPOC,
  handleAddToGroup,
  fetchCollegeList,
  fetchGroupList,
  setTotalCollegeCount,
  totalCollegeCount,
  groupCount,
  groupData,
  collegeData,
  setCollegeData,
  setGroupCount,
  setGroupData,
  handleAdd,
  handleDelete,
  handleEdit,
  handleAddQueue,
  handleSort,
  onSelectChange,
  onPageChange,
  showDeleteGroupPopup,
  showDuplicatePopup,
  selectedColleges,
  setSelectedColleges,
  onCollegeSelectChange,
  loading,
  setLoading,
  pageNum,
  pageLimit,
  selectedCollegeIds,
  onSingleRowSelect,
  onSelectAllRows,
  onViewSelectedColleges,
  handleCreateNewGroup,
  selectedGroupPagination,
  onTabChange,
  collegeFilters,
  setCollegeFilters,
  handleCollegeFilterChange,
  filterData,
  collegeSearch,
  setCollegeSearch,
  searchValue,
  currentGroupSearch,
  selectedGroupIds,
  handlePublishRole,
  handleSkip,
  isEditRoleOnView,
  isRepublishMode,
  publishedIds = [],
  publishedCount = 0,
  onViewPublished,
  stateOptions = [],
  cityOptions = [],
  onStateSearch,
  onCitySearch,
  onStateDropdownClose,
  onCityDropdownClose,
}) => {
  const [tableType, setTableType] = useState('college')

  useEffect(() => {
    fetchCollegeList()
    fetchGroupList()
  }, [])

  return (
    <>
      <BodyStyleDiv>
        <GroupCollegeHeader
          stateOptions={stateOptions}
          cityOptions={cityOptions}
          onStateSearch={onStateSearch}
          onCitySearch={onCitySearch}
          onStateDropdownClose={onStateDropdownClose}
          onCityDropdownClose={onCityDropdownClose}
          handlePublishRole={handlePublishRole}
          handleSkip={handleSkip}
          isEditRoleOnView={isEditRoleOnView}
          isRepublishMode={isRepublishMode}
          publishedIds={publishedIds}
          publishedCount={publishedCount}
          onViewPublished={onViewPublished}
          collegeSearch={collegeSearch}
          setCollegeSearch={setCollegeSearch}
          filterData={filterData}
          tableType={tableType}
          setTableType={setTableType}
          setviewGroupCollege={setviewGroupCollege}
          collegeData={collegeData}
          setCollegeData={setCollegeData}
          groupData={groupData}
          setGroupData={setGroupData}
          loading={loading}
          setLoading={setLoading}
          pageNum={pageNum}
          pageLimit={pageLimit}
          totalCollegeCount={totalCollegeCount}
          setGroupCreationDrawerVisible={setGroupCreationDrawerVisible}
          groupCreationDrawerVisible={groupCreationDrawerVisible}
          groupCount={groupCount}
          handleEditTier={handleEditTier}
          handleEditPOC={handleEditPOC}
          pocList={pocList}
          handleAddPOC={handleAddPOC}
          handleAddToGroup={handleAddToGroup}
          handleAdd={handleAdd}
          handleDelete={handleDelete}
          handleEdit={handleEdit}
          handleAddQueue={handleAddQueue}
          handleSort={handleSort}
          onSelectChange={onSelectChange}
          onPageChange={onPageChange}
          showDeleteGroupPopup={showDeleteGroupPopup}
          showDuplicatePopup={showDuplicatePopup}
          selectedColleges={selectedColleges}
          onCollegeSelectChange={onCollegeSelectChange}
          selectedCollegeIds={selectedCollegeIds}
          onSingleRowSelect={onSingleRowSelect}
          onSelectAllRows={onSelectAllRows}
          onViewSelectedColleges={onViewSelectedColleges}
          handleCreateNewGroup={handleCreateNewGroup}
          selectedGroupPagination={selectedGroupPagination}
          onTabChange={onTabChange}
          collegeFilters={collegeFilters}
          setCollegeFilters={setCollegeFilters}
          handleCollegeFilterChange={handleCollegeFilterChange}
          fetchGroupList={fetchGroupList}
          searchValue={searchValue}
          currentGroupSearch={currentGroupSearch}
          selectedGroupIds={selectedGroupIds}
        />
      </BodyStyleDiv>
    </>
  )
}

export default GroupCollegeDrawer
